import { colors } from "../data/colors";
import { emptysDates } from "../data/main";
import { stdObject } from "../data/types/stdObject";
import { convertAge } from "./convertAge";
import convertDate from "./convertDate";
import { getRealCode } from "./getRealCode";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import { toPrice } from "./toPrice";

export const convertCellData = ({
  key,
  section,
  data,
  country,
  t,
}: {
  key: string;
  section: string;
  data: any;
  country: any;
  t: any;
}) => {
  let code = getRealCode(key, section);
  if (key.startsWith("ALM") && !key.endsWith("ART")) {
    return data[key];
  }
  switch (code) {
    case "IMG":
      return { code, data: data.IMGART };
    case "ADJ":
      return {
        code,
        Icon: data[key] === 1 ? FolderIcon : FolderOffIcon,
        color: data[key] === 1 ? colors.cream : colors.grey,
      };
    case "TIM":
      return {
        code,
        data: emptysDates.includes(data.start)
          ? false
          : convertAge(data.start, data.end),
      };
    case "FEC":
    case "FEC2":
    case "FEC4":
    case "NAC":
      return convertDate({
        info: data[key] as string,
        time: ["FEC", "FEC2", "FEC4"].includes(code),
        t,
      });
    case "PRE":
      let tempPrices =
        "PREART" in data && country in data.PREART
          ? { ...data.PREART[country] }
          : {};
      Object.keys(tempPrices).forEach(
        (e) => (tempPrices[e] = tempPrices[e].PRELTA),
      );
      return { code, data: tempPrices };
    case "ALM":
      return { code, data: data[key] };
    case "TOT":
    case "ABO":
    case "SAL":
      return toPrice(data[key]);
    case "DOM":
      return {
        code,
        data: Array.isArray(data[`DOM${section}`])
          ? data[`DOM${section}`].map((e: stdObject) => {
              return { DOM: e.DOMDIR, GPS: [e.LATDIR, e.LONDIR] };
            })
          : [{ DOM: data[`DOM${section}`], GPS: [] }],
      };
    case "NOMPAG":
      return data.PAGSEV;
    case "ITEMS":
      return Array.isArray(data[key])
        ? {
            code,
            data: data[key],
          }
        : "";
    case "PREPCO":
      return data[code] && country in data[code]
        ? toPrice(data[code][country])
        : "";
    default:
      return data[key] ?? "";
  }
};
